import React, { useEffect, useState } from 'react'
import { Drawer, notification, Input, DatePicker, Row, Col } from 'antd'
import { InputBox } from '../../../components/_utils/appUtils'
import { addEventXTravelFxn, getEventDataById } from '../actions'
import { useDispatch } from 'react-redux'
import { listAllCountries } from '../../countries/actions/countries'
import moment from 'moment'

let eventInitialState = {
  name: '',
  startDate: null,
  endDate: null,
  countryId: '',
  venue: '',
  address: ''
}

const AddEventXTravelWorld = (props) => {
  let [eventState, setEventState] = useState(eventInitialState)
  const [countryList, setCountryList] = useState([])
  let dispatch = useDispatch()
  let { visible, onClose, onSubmit, pageName, eventId } = props
  let events = {
    updateEventState: (data) => {
      setEventState((prevState) => {
        return {
          ...prevState,
          ...data
        }
      })
    },
    handleSubmit: async (e) => {
      e.preventDefault()

      if (!eventState.name) {
        return notification.warning({ message: 'Please Enter Event Name' })
      }
      if (!eventState.startDate) {
        return notification.warning({ message: 'Please Choose Start Date' })
      }
      if (!eventState.endDate) {
        return notification.warning({ message: 'Please Choose End Date' })
      }
      if (!eventState.countryId) {
        return notification.warning({ message: 'Please Choose Country' })
      }
      if (!eventState.venue) {
        return notification.warning({ message: 'Please Enter Venue Name' })
      }
      if (eventId) {
        eventState.eventId = eventId
      }
      let resp = await dispatch(addEventXTravelFxn(eventState))
      if (resp && resp.success) {
        setEventState(eventInitialState)
        onSubmit()
      }
    }
  }
  const loadCountryFxn = async () => {
    let params = {
      results: 100,
      count: 100,
      active: [true]
    }
    let x = await dispatch(listAllCountries(params))
    setCountryList(x.data)
  }

  useEffect(() => {
    loadCountryFxn()
  }, [])

  const loadEventData = async () => {
    let { data } = await dispatch(getEventDataById({ eventId }))
    if (data) {
      setEventState({
        name: data.name,
        startDate: moment(data.startDate) || null,
        endDate: moment(data.endDate) || null,
        countryId: data.countryId,
        venue: data.venue,
        address: data.address
      })
    }
  }

  useEffect(() => {
    loadEventData()
  }, [eventId])
  return (
    <>
      <Drawer title={`${pageName} Event`} width={'50%'} onClose={onClose} visible={visible}>
        <div className='row'>
          <div className='col-lg-12'>
            <div className='card'>
              <Row gutter={24}>
                <Col span={8}>
                  <InputBox title={'Event Name*'}>
                    <Input size={'small'}
                           className='form-control'
                           type={'text'}
                           placeholder={'Enter Event Name'}
                           value={eventState.name}
                           onChange={(value) => {
                             events.updateEventState({ name: value.target.value })
                           }}
                    />
                  </InputBox>
                </Col>
                <Col span={8}>
                  <InputBox title={'Start Date*'}>
                    <DatePicker
                      className={'form-control'}
                      value={eventState.startDate}
                      onChange={(value) => {
                        events.updateEventState({ startDate: value })
                      }}
                    />
                  </InputBox>
                </Col>
                <Col span={8}>
                  <InputBox title={'End Date*'}>
                    <DatePicker
                      className={'form-control'}
                      value={eventState.endDate}
                      onChange={(value) => {
                        events.updateEventState({ endDate: value })
                      }}
                    />
                  </InputBox>
                </Col>
                <Col span={8}>
                  <InputBox title={'Country*'}>
                    <select
                      className={'form-control'}
                      value={eventState.countryId}
                      onChange={({ target }) => {
                        events.updateEventState({ countryId: target.value })
                      }}>
                      <option value={''}>Choose Country</option>
                      {countryList && countryList.length && countryList.map((item) => {
                        return (
                          <option key={item._id} value={item._id}>
                            {item.countryName}
                          </option>
                        )
                      })}
                    </select>
                  </InputBox>
                </Col>
                <Col span={8}>
                  <InputBox title={'Venue'}>
                    <Input size={'small'}
                           className='form-control'
                           type={'textArea'}
                           placeholder={'Enter Details'}
                           value={eventState.venue}
                           onChange={(value) => {
                             events.updateEventState({ venue: value.target.value })
                           }}
                    />
                  </InputBox>
                </Col>
                <Col span={24}>
                  <InputBox title={'Address'}>
                    <Input
                      className='form-control'
                      type={'textArea'}
                      placeholder={'Enter Address'}
                      value={eventState.address}
                      onChange={(value) => {
                        events.updateEventState({ address: value.target.value })
                      }}
                    />
                  </InputBox>
                </Col>
                <Col span={24}>
                  <a className='btn btn-primary'
                     onClick={events.handleSubmit}
                  >
                    Submit
                  </a>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </Drawer>
    </>
  )
}
export default AddEventXTravelWorld
